import {cloneDeep} from "lodash";
import {getString} from "Core/helpers/data";
import {ApplicationParametersListItemDataObject} from "../dataObjects";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {ApplicationParametersListItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new ApplicationParametersListItemDataObject(
		getString(result, 'id'),
		getString(result, 'applicationName'),
		getString(result, 'paramName'),
		getString(result, 'paramValue')
	);

	return result;
}

// @note There is no output function since list is read only.